import React from 'react'
import Header from '../components/header'

export default () => (
  <div>
    <Header />
    <div>About Us</div>
    <footer>Footer</footer>
  </div>
)